import { Divider, Icon, ImageVideoSlider } from "components/common";
import styles from "./index.module.less";
import { useState } from "react";
import SchemaModal from "../addScriptForm/schemaModal";

const ScriptSchemaSection = ({ details }) => {
  const [selectedSchema, setSelectedSchema] = useState(null);

  if (!details?.schemas?.length) return null;

  return (
    <div id={"Schemas"} className={styles.schemaSection}>
      <div className={styles.schemaHeader}>
        <div className={styles.schemaTitle}>
          <span>Schemas</span>
        </div>
        <div className={styles.schemaCount}>
          {details.schemas.length}{" "}
          {details.schemas.length === 1 ? "Schema" : "Schemas"}
        </div>
      </div>

      <ImageVideoSlider
        dataList={details.schemas.map((e) => ({ ...e, type: "schema" }))}
        width={"25%"}
        height={125}
        onClickSchema={(e, index) => {
          setSelectedSchema({
            title: `Schema ${index}`,
            type: "schema",
            data: JSON.parse(e?.json),
          });
        }}
      />

      {/* <div className={styles.schemaGrid}>
        {details.schemas.map((schema, index) => (
          <div
            key={index}
            className={styles.schemaTile}
            onClick={() => {
              setSelectedSchema({
                title: `Schema ${index + 1}`,
                type: "schema",
                data: JSON.parse(schema?.json),
              });
            }}
          >
            <div className={styles.schemaIcon}>
              <Icon size={24} icon="MdStorage" />
            </div>
            <div className={styles.schemaContent}>
              <div className={styles.schemaName}>Schema {index + 1}</div>
              <div className={styles.schemaSubtitle}>Click to view details</div>
            </div>
            <div className={styles.schemaArrow}>
              <Icon size={16} icon="MdArrowForwardIos" />
            </div>
          </div>
        ))}
      </div> */}

      <Divider />

      <SchemaModal
        onConfirm={() => {}}
        visible={selectedSchema}
        setIsVisible={setSelectedSchema}
        schemaData={selectedSchema}
        destroyOnClose
        onCancel={() => {
          setSelectedSchema(null);
        }}
        viewOnly={true}
      />
    </div>
  );
};

export default ScriptSchemaSection;
